/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMilQuickOrder contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum displayedInventoryMethod {
    totalAvailable = 'totalAvailable',
    physicalAvailable = 'physicalAvailable'
}

export interface IMilQuickOrderConfig extends Msdyn365.IModuleConfig {
    maxQuantity?: number;
    className?: string;
    clientRender?: boolean;
    displayedInventoryMethod?: displayedInventoryMethod;
}

export interface IMilQuickOrderResources {
    quickOrderModuleHeading: string;
    quickOrderModuleDescription: string;
    quickOrderProductInputLabel: string;
    quickOrderProductQuantityInputLabel: string;
    quickOrderAddtobag: string;
    quickOrderOutOfStock: string;
    quickOrderAddedToCartSuccessMessage: string;
    quickOrderAddedToCartFailureMessage: string;
    quickOrderMaxQuantityLimitText: string;
    quickOrderAlreadyItemQuantityText: string;
    quickOrderSelectDimensionFormatString: string;
    quickOrderProductDimensionTypeColor: string;
    quickOrderProductDimensionTypeConfiguration: string;
    quickOrderProductDimensionTypeSize: string;
    quickOrderProductDimensionTypeStyle: string;
    quickOrderProductDimensionTypeAmount: string;
    quickOrderproductDimensionTypeColorErrorMessage: string;
    quickOrderproductDimensionTypeConfigurationErrorMessage: string;
    quickOrderproductDimensionTypeSizeErrorMessage: string;
    quickOrderproductDimensionTypeStyleErrorMessage: string;
    quickOrderproductDimensionTypeAmountErrorMessage: string;
    quickOrderWrongQuantityErrorMsg: string;
    quickOrderOutofStockErrorMsg: string;
    quickOrderProductNumberText: string;
    quickOrderProductText: string;
    quickAddQuantityPlaceholderText: string;
    quickOrderUnitPriceText: string;
    quickOrderUnitOfMeasureText: string;
    quickOrderQuantityText: string;
    quickOrderTotalText: string;
    quickOrderActionsText: string;
    quickOrderQuantityMobileText: string;
    quickOrderProductDimensionsSeparator: string;
    quickOrderViewDetailsButtonText: string;
    quickOrderViewDetailsButtonAriaLabel: string;
    quickOrderRemoveItemButtonAriaLabel: string;
    quickOrderInputQuantityAriaLabel: string;
    quickOrderDecrementButtonAriaLabel: string;
    quickOrderIncrementButtonAriaLabel: string;
}

export interface IMilQuickOrderProps<T> extends Msdyn365.IModule<T> {
    resources: IMilQuickOrderResources;
    config: IMilQuickOrderConfig;
}
